import React from "react"
import {missing_err, display_list } from './SnapUtils'
import { hard2easy } from '../../variables/ComboValues'
import { calcIncomeSum, calcTotalIncome, calcTotalIncomeByClass2, calcTotalbyField, calcTotalExpensesByClass } from '../Tree/Utils'

export const display_family_rights = (title, table) => {
    if (table === undefined || table === false || table.length === 0)
        return null
    const t = table.map((line, index) => {
        if (line['rights_sum'] === "" && line['rights_pay_type'] === "") return null
        return (
            <div className="improve-line" key={index}>
                <span className="improve-field">{title}</span>
                <span className="improve-label">{line['rights_name']}</span>
                <div className='improve-item'>
                    <span>{line['rights_sum']} | {line['rights_pay_type']} | {line['rights_frequency']}</span>
                </div>
            </div>
        )
    })
    return t
}
export const compare_list_legal = (title, list, list2, labels) => {
    if (list === undefined || list === false || list2 === undefined || list2 === false)
        return test_lists_exists(list,list2, title, labels)

    //return compareYesNo(list['need_legal'], list2['need_legal'], labels['need_legal'])
    const f = 'need_legal'
    const NoYes = true
    return compareYesNo(NoYes, list[f], list2[f],  title, labels[f]) // list_result(f, title, list, list2, labels, NoYes)
    //return <div className='improve-line'><h4>{title}</h4>{compareYesNo(list[f], list2[f], labels[f])}</div>
}

export const compare_list_housing = (title, list, list2, labels) => {
    if (list === undefined || list === false || list2 === undefined || list2 === false)
        return test_lists_exists(list,list2, title, labels)
    
    const f = 'family_house_status'
    const NoYes = true
    return compareYesNo(NoYes, list[f], list2[f],  title, labels[f]) //list_result(f, title, list, list2, labels, NoYes)
    //<div className='improve-line'><h4>{title}</h4>{compareYesNo(list[f], list2[f], labels[f])}</div>
}

export const compare_list_doUsave = (title, list, list2, labels) => {
    if (list === undefined || list === false || list2 === undefined || list2 === false)
        return test_lists_exists(list,list2, title, labels)
    
    const f = 'do_u_save' // NoYes is improvement
    const NoYes = false
    return compareYesNo(NoYes, list[f], list2[f],  title, labels[f]) // list_result(f, title, list, list2, labels, NoYes)
    //<div className='improve-line'><h4>{title}</h4>{compareYesNo(list[f], list2[f], labels[f])}</div>
}
// מיצוי זכויות
export const compare_list_rigtsq = (title, list, list2, labels) => {
    if (list === undefined || list === false || list2 === undefined || list2 === false)
        return test_lists_exists(list,list2, title, labels)
    
    let result = Object.keys(list).map ( (f, index) => {
        if (list[f] === "" && list2[f] === "")
            return null
        if (list[f].indexOf('כן') > -1){
            if (list2[f] !== 'בוצע') // regular yes no answer
                return compareYesNo(true, list[f], list2[f],  title, labels[f])
            return compareYN(list2[f] === 'בוצע', list[f], list2[f],  title, labels[f])
        } if (!isNaN(list[f]) && isNaN(list2[f]))
            return compareYN(parseInt(list[f]) < parseInt(list2[f]), list[f], list2[f],  title, labels[f])

        return compareYN(true, list[f], list2[f],  title, labels[f]) // no idea what might come up
    })
    
    return result
}

export const compare_list_prodservices = (title, list, list2, labels) => {
    if (list === undefined || list === false || list2 === undefined || list2 === false)
        return test_lists_exists(list,list2, title, labels)
    
    const inverseLogic = ['q31', 'q32', 'q33']

    let result = Object.keys(list).map ( (f) => {
        if (list[f] === "" && list2[f] === "")
            return null
        if (inverseLogic.includes(f)){
            if (list[f] === 'כן' && list2[f] === 'כן') return null // we dont care
            return compareYesNo(false, list[f], list2[f],  title, labels[f])
        }
        // if missing yes => no its good
        if (f >='q201' && f <= 'q220'){
            if (list[f] === 'לא') return null // we dont care
            return compareYesNo(true, list[f], list2[f],  title, labels[f])
        }
        if (list[f] === "לא" && list[f] === list2[f])
            return null
        if (f >= 'q401'){
            if (list[f] === "" || list2[f] === "" || list[f] === list2[f]) return null 
            let iof1 = hard2easy.indexOf(list[f]) 
            let iof2 = hard2easy.indexOf(list2[f])
            ////console.log('hard2easy = iof1'+ iof1 + ' iof2 = ' + iof2 )
            return compareYN(iof1 < iof2, list[f], list2[f],  title, labels[f])
        }
        ////console.log("ps f=", f)
        return compareYesNo(true, list[f], list2[f],  title, labels[f])
    })
    
    return result
}

export const compare_balance_improve = (field, cpt, cpt2, snap) => {

    const start = get_balance_from_table(cpt);
    const end = get_balance_from_table(cpt2);
    //console.log('compare_balance_improve beg=', start, end)
    //         {SumTable2(products,'income_sum', 'income_frequency', 'work', 'הכנסות מעבודה')}
    const work_start = calcTotalIncomeByClass2(cpt['family_income'], 'income_sum', 'work')
    const work_end = calcTotalIncomeByClass2(cpt2['family_income'], 'income_sum', 'work')
    const inright_start = calcTotalIncomeByClass2(cpt['family_income'], 'income_sum', 'rights')
    const inright_end = calcTotalIncomeByClass2(cpt2['family_income'], 'income_sum', 'rights')
    const hon_start = calcTotalIncomeByClass2(cpt['family_income'], 'income_sum', 'capital')
    const hon_end = calcTotalIncomeByClass2(cpt2['family_income'], 'income_sum', 'capital')
    const total_expenses_start = calcTotalbyField(cpt['family_expenses'], 'expense_sum')
    const total_expenses_end = calcTotalbyField(cpt2['family_expenses'], 'expense_sum')
    const total_debts_start = calcTotalbyField(cpt['family_debts'], 'family_debt_orig_sum')
    const total_debts_end = calcTotalbyField(cpt2['family_debts'], 'family_debt_orig_sum')
    const total_mort_start = calcTotalbyField(cpt['family_mortgage'], 'mortgage_sum')
    const total_mort_end = calcTotalbyField(cpt2['family_mortgage'], 'mortgage_sum')
    const exp_comm_start = calcTotalExpensesByClass(cpt['family_expenses'], 'expense_sum', 'communication')
    const exp_comm_end = calcTotalExpensesByClass(cpt2['family_expenses'], 'expense_sum', 'communication')
    const exp_housing_start = calcTotalExpensesByClass(cpt['family_expenses'], 'expense_sum', 'housing').toLocaleString('he-IL')
    const exp_housing_end = calcTotalExpensesByClass(cpt2['family_expenses'], 'expense_sum', 'housing').toLocaleString('he-IL')
    const need_solution_cost = calcTotalbyField(cpt2['needsolution_array'], 'needsolution_cost')
    const team_cost = Math.round(7000*24/8)
    const sroit = parseInt(work_end - work_start + hon_end - hon_start + inright_end - inright_start + total_expenses_start - total_expenses_end)
    const sroi = Math.round( sroit * 24 / (need_solution_cost + team_cost) * 100)
    const strc = "[עבודה= " + (work_end - work_start).toLocaleString('he-IL') 
                + " + קצבאות= " + (inright_end - inright_start).toLocaleString('he-IL')
                + " + הון= " + (hon_end - hon_start).toLocaleString('he-IL')
                + " + ירידה בהוצאות= " + (total_expenses_start - total_expenses_end).toLocaleString('he-IL')
                + "] "
                + "לשנתיים = " + ((hon_end - hon_start + work_end - work_start + inright_end - inright_start)*24).toLocaleString('he-IL')
                + " מחולק [ בעלות מענים = " + need_solution_cost.toLocaleString('he-IL')
                + "+ עלות מלווה משפחה = " + team_cost.toLocaleString('he-IL') + "]"
    return ( 
        <React.Fragment>
            <div style={{marginRight:'30px'}}>
                <h3>מדד SROI למשפחה = {sroi}%</h3>
                <h5>מתקבל מתוך: {strc}</h5>
                <ul><li>לא נלקחות בחשבון הכנסות חד פעמיות ממיצוי זכויות</li></ul>
            </div>

            {compare_GTLT(false, tol(start.balance), tol(end.balance), field, 'פער הכנסות מול הוצאות')}
            {compare_GTLT(true, start.income, end.income, field, 'סה"כ הכנסות חודשי')}
            {compare_GTLT(true, work_start, work_end, field, 'הכנסות מעבודה')}
            {/*console.log("work income strt=" + tol(work_start) + "work income end="+ tol(work_end))*/}
            {compare_GTLT(true, tol(inright_start), tol(inright_end), field, 'הכנסות מקצבאות')}
            {compare_GTLT(hon_end > hon_start, tol(hon_start), tol(hon_end), field, 'הכנסות מהון')}
            {compare_GTLT(false, start.expenses, end.expenses, field, 'סה"כ הוצאות חודשי')}
            {compare_GTLT(false, start.debts, end.debts, field, 'החזר חובות חודשי')}
            {compare_GTLT(false, total_debts_start, total_debts_end, field, 'סה"כ חובות')}
            {compare_GTLT(false, start.mort, end.mort, field, 'משכנתאות החזר חודשי')}
            {compare_GTLT(false, total_mort_start, total_mort_end, field, 'סה"כ משכנתאות')}
            {compare_GTLT(true, start.savings, end.savings, field, 'חסכון לילדים')}
            {compare_GTLT(false, exp_comm_start, exp_comm_end, field, 'הוצאות תקשורת חודשי')}
            {compare_GTLT(false, exp_housing_start, exp_housing_end, field, 'הוצאות דיור חודשי')}

        </React.Fragment>
    )
}
const tol = (f) => f.toLocaleString('he-IL')

function get_balance_from_table(cpt){
    var beg = {
        expenses : calcIncomeSum(cpt['family_expenses'],'expense_sum'),
        debts    : calcIncomeSum(cpt['family_debts'],'family_debt_monthlyreturn'),
        mort     : calcIncomeSum(cpt['family_mortgage'],'mortgage_monthly'),
        income   : calcTotalIncome(cpt['family_income'],'income_sum','income_frequency'),
        savings  : parseInt(cpt['family_savings']['monthly_savings_avg']),
        balance: 0, 
        debts_percent: 0,
        mort_percent: 0,
        total_expenses: 0
    }
    beg.balance  = parseInt(beg.income) - (parseInt(beg.expenses)+parseInt(beg.debts)+parseInt(beg.mort)+parseInt(beg.savings))
    //beg.balance  = beg.income - (beg.expenses+beg.debts+beg.mort+beg.savings)
    beg.debts_percent = beg.debts > 0 ? Math.round(beg.debts / beg.income*100) : 0
    beg.mort_percent  = beg.mort  > 0 ? Math.round(beg.mort / beg.income*100) : 0
    beg.total_expenses= beg.debts + beg.mort + beg.expenses + beg.savings
    beg.total_expenses= beg.total_expenses.toLocaleString('he-IL')
    return beg
}
function compare_GTLT(LessThan, initialValue, lastValue,  field, label){
    let s1 = ''
    //console.log('compare_GTLT initial='+initialValue+"  last="+lastValue)
    if (initialValue === "" || lastValue === "")
        s1 = <span className='improve-result'>חסרים נתונים להשוואה</span>
    else if (initialValue === lastValue)
        s1 = show_improve('eq', initialValue, lastValue ) // no chane
    else if (LessThan)
        s1 = show_improve(initialValue < lastValue, initialValue, lastValue )
    else s1 = show_improve(initialValue > lastValue, initialValue, lastValue )

    return (
        <div className="improve-line">
            <span className="improve-field">{field}</span>
            <span className="improve-label">{label}</span>
            <div className='improve-item'>{s1}</div>
        </div>
        )
}

function compareYN(cond, initialValue, lastValue, field, label){
    let str = show_improve(cond, initialValue, lastValue )
    let key = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36)   

    return (<div key={key} className="improve-line">
                <span className="improve-field">{field}</span>
                <span className="improve-label">{label}</span>
                <div className='improve-item'>{str}</div>
            </div>)
}

//function list_result(f, title, list, list2, labels, NoYes){
//    return compareYesNo(NoYes, list[f], list2[f],  title, labels[f])
//}
// test yes to no field value. Yes to No is an improvements 
// improve-item
//     improve=lable improve-result
function compareYesNo(NoYes, initialValue, lastValue, field, label){
    let s1 = ''
    if (initialValue === "" || lastValue === "")
        s1 = <span className='improve-result'>חסרים נתונים להשוואה</span>
    else if (initialValue === lastValue)
        s1 = show_improve('eq', initialValue, lastValue ) // no chane
    else if (NoYes)
        s1 = show_improve(initialValue === 'כן' && lastValue === 'לא', initialValue, lastValue )
    else
        s1 = show_improve(initialValue === 'לא', initialValue, lastValue )

    let key = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36)   
    return (<div key={key} className="improve-line">
                <span className="improve-field">{field}</span>
                <span className="improve-label">{label}</span>
                <div className='improve-item'>{s1}</div>
            </div>)
}
function test_lists_exists(list,list2, title, labels){
    if (list === undefined || list === false )
        return <div className='improve-line'><span className='improve-field'>{title}</span>{missing_err("חסרה הגדרה של כל נתוני הרשימה הראשונה")}</div>
    if (list2 === undefined || list2 === false ){
        //missing_err("חסרה הגדרה של כל נתוני הרשימה השניה")
        return <div className='improve-line'><span className='improve-field'>{title}</span>{ missing_err("חסרה הגדרה של כל נתוני הרשימה השניה")}<br />{display_list(list, labels)} </div>
    }
    return null
}
// show improve true/false/empty
// true is improve depending on the condition in the call
// cond === 'eq' - no change
function show_improve(cond, initialValue, lastValue){
    const imp = cond === "eq" ? <span className="improve-same"><span className="improve-symbol">==</span> <span className="improve-text"> ללא שינוי</span></span>: 
                cond === true ? <span className="improve-up"><span className="improve-symbol">&uarr;</span><span className="improve-text">חל שיפור</span></span> : 
                         <span className="improve-down"><span className="improve-symbol">&darr;</span><span className="improve-text">חלה ירידה</span></span>
    return (<span className='improve-result'>
                <span className="improve-start">{isNaN(initialValue) ? initialValue : tol(initialValue)}</span>
                <span className="improve-end">{isNaN(lastValue)? lastValue : tol(lastValue)}</span>
                <span className="improve-res">{imp}</span>
            </span>) // hand-point-up
}

export function display_compare_title(title, field, init, last, imp){ 
    return( <div className='improve-line' style={{fontWeight:'600', marginTop:'40px', marginBottom:'20px'}}>
                <span className='improve-field'>{title}</span>
                <span className='improve-label'>{field}</span>
                <div className='improve-item'>
                    <span className='improve-result'>
                        <span className="improve-start">{init}</span>
                        <span className="improve-end">{last}</span>
                        <span className="improve-res">{imp}</span>
                    </span>
                </div>
            </div>)
}
